module.exports = __webpack_public_path__ + "static/media/event.b917308c.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/event.jpg
 ** module id = 692
 ** module chunks = 0
 **/